import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    .filter_icon_box{
        width: 30px;
        height: 30px;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &:hover{
            border-radius: 6px;
            background-color: rgba(116, 176, 234, 0.25) !important;
        }  
    }
    .active_filter_button{
        background-color: rgba(116, 176, 234, 0.25);
        font-weight: bold;
        border: none;
        &:hover{
            background-color: rgba(116, 176, 234, 0.25) !important;
            font-weight: bold;
            border: none;
            color: #000 !important;
        }
    }

    .yet-designed-pages {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .developement-content {
    font-size: 1.266rem;
    line-height: 1;
    color: rgb(0, 0, 0);
    margin-bottom: 1rem;
  }
  .developement-span-content {
    font-size: 1.125rem;
    font-weight: 400;
    color: rgb(158, 165, 169);
    margin-bottom: 1rem;
  }
  .developement-add-button {
    font-size: 0.889rem;
    height: 2.5rem;
    min-width: 2.5rem;
    color: rgb(255, 255, 255);
    background-color: rgb(27, 104, 179);
    border: 1px solid rgb(27, 104, 179);
  }

  .events_data_container{
        display: flex;
        flex-direction: column;
        text-align: justify;
    }
    .events_header_section{
        font-weight: 700;
        padding: 16px 6px;
        border-bottom: 1px solid rgb(158, 165, 169);
        background-color: rgb(245, 245, 246);
    }
    .events_data_box_container{
        text-align: justify;
    }
    .events_data_box{
        padding: 2px 6px;
        display: flex;
        align-items: center;
        gap: 10px;

        &:hover{
            background: rgba(116, 176, 234, 0.25);
        }
    }
    .events_data_box:nth-child(even) {
        background-color: rgb(245, 245, 246);
        &:hover{
            background: rgba(116, 176, 234, 0.25);
        }
    }
    .creation-date{
        color: rgb(92, 100, 104);
        font-size: 12px;
        margin-bottom: 4px;
    }

    .event_name{
        font-size: 0.889rem;
        font-weight: 400;
        margin-top: 6px;
    }
    .event-backward-img-box{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 32px;
        width: 32px;
        border-radius: 5px;
        background: rgba(116, 176, 234, 0.25);
        cursor: pointer;
    }
    .event-backward-img{
        rotate: 270deg;
        font-size: 20px;
        color: rgb(27, 104, 179);
    }

    .editIcon{
        font-size: 20px;
    }
    .deleteIcon{
        font-size: 20px;
    }
    .cloneIcon{
        font-size: 20px;
    }
    .user-remove-icon{
        font-size: 20px;
    }
    .ellipsisIcon{
        font-size: 20px;
    }
    .table_action_icons{
        display: flex;
        gap: 12px;
        justify-content: end;
    }

    // .ant-layout.ant-layout-has-sider {
    //     flex-direction: row;
    //     min-height: 92% !important;
    //     ::-webkit-scrollbar {
    //         width: 0px;
    //         background: transparent; /* make scrollbar transparent */
    //     }
        
    // }

    .ant-layout {
        display: flex;
        flex: auto;
        flex-direction: column;
        min-height: unset !important;
        height: 100%;
        background: #f5f5f5 !important;
    }
    .modal_title{
        margin-top: 0;
    }
`;

export default GlobalStyle;